module.exports = __webpack_public_path__ + "fa-regular-400.6bf63c80836c0b844942bb35544e28c8.ttf";